module.exports = __webpack_public_path__ + "static/img-question-food.958c8183.jpg";